import React from "react";
import { ArrivalLogs } from "../views/ArrivalLogs/ArrivalLogs";
import { BatteryLevelDashboard } from "../views/BatteryLevelDashboard";
import { CommonAreaAccess } from "../views/CommonAreaAccess";
import { CommonDoorSchedule } from "../views/CommonDoorSchedule/CommonDoorSchedule";
import { GymCompetency } from "../views/GymCompetency";
import { Home } from "../views/Home";
import { IotDeviceDashboard } from "../views/IotDeviceDashboard";
import { IotGatewayDashboard } from "../views/IotGatewayDashboard";
import { Maintenance } from "../views/Maintenance";
import { SpokeDashboard } from "../views/SpokeDashboard";
import { UserGroup } from "../enums/UserGroup";
import { VillageWifi } from "../views/VillageWifi/VillageWifi";
import { CardSwap } from "../views/CardSwap/CardSwap";
import BatteryCharging80Icon from '@mui/icons-material/BatteryCharging80';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import HomeIcon from '@mui/icons-material/Home';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import MobiledataOffIcon from '@mui/icons-material/MobiledataOff';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import WifiIcon from '@mui/icons-material/Wifi';
import FlightLandIcon from '@mui/icons-material/FlightLand';
import ConstructionIcon from "@mui/icons-material/Construction";
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';



export type View = {
    
    component: React.ReactNode;
    display: boolean;
    icon: React.ReactElement;
    index: number;
    path: string;
    text: string;
    userGroups: UserGroup[ ]

}


const views: View[] = [
    
    {
        component: <Home />
        , display: false
        , icon: <HomeIcon/>
        , index: 0
        , path: '/'
        , text: 'Home'
        , userGroups: [ ]

    },

    {
        component: <GymCompetency />
        , display: true
        , icon: <FitnessCenterIcon/>
        , index: 1
        , path: '/gym-competency'
        , text: 'Gym Competency'
        , userGroups: [ UserGroup.ExternalGymUsers, UserGroup.GymCompetency, UserGroup.ESSSupervisor, UserGroup.NPIOps ]
    },

    {
        component: <CommonAreaAccess />
        , display: true
        , icon: <HomeWorkIcon/>
        , index: 2
        , path: '/common-area-access'
        , text: 'Common Area Access'
        , userGroups: [ UserGroup.CommonAreaAccess, UserGroup.ESSSupervisor, UserGroup.NPIHousing, UserGroup.NPIOps ]
    },

    {
        
        component: <BatteryLevelDashboard />
        , display: true
        , icon: <BatteryCharging80Icon/>
        , index: 3
        , path: '/battery-monitor'
        , text: 'Guest Door Battery'
        , userGroups: [ UserGroup.BatteryMonitor, UserGroup.ExternalBatteryMonitor ]

    },

    {
        
        component: <IotDeviceDashboard />
        , display: true
        , icon: <DeviceHubIcon/>
        , index: 4
        , path: '/iot-device'
        , text: 'Guest Door Connection'
        , userGroups: [ UserGroup.IotDeviceDashboard, UserGroup.ExternalIotDeviceDashboard ]

    },

    {
        
        component: <IotGatewayDashboard />
        , display: true
        , icon: <MobiledataOffIcon/>        
        , index: 5
        , path: '/iot-gateway'
        , text: 'IoT Gateway Status'
        , userGroups: [ UserGroup.IotGatewayDashboard, UserGroup.ExternalIotGatewayDashboard ]

    },

    {
        
        component: <SpokeDashboard />
        , display: true
        , icon: <MonitorHeartIcon/>        
        , index: 6
        , path: '/spoke'
        , text: 'System Health'
        , userGroups: [ UserGroup.SpokeDashboard ]

    },

    {
        
        component: <VillageWifi />
        , display: true
        , icon: <WifiIcon/>        
        , index: 7
        , path: '/village-wifi'
        , text: 'Village Wi-Fi'
        , userGroups: [ UserGroup.VillageWiFi ]

    },

    {
        
        component: <CardSwap />
        , display: true
        , icon: <ChangeCircleIcon/>        
        , index: 8
        , path: '/card-swap'
        , text: 'Card Swap'
        , userGroups:  [ UserGroup.WaioReception, UserGroup.WaioSecurity ] 

    },

    {
        
        component: <ArrivalLogs />
        , display: true
        , icon: <FlightLandIcon/>        
        , index: 9
        , path: '/arrival-logs'
        , text: 'Arrival Logs'
        , userGroups:  [ UserGroup.Diagnostics ]

    },

    {
        
        component: <CommonDoorSchedule />
        , display: true
        , icon: <MeetingRoomIcon/>        
        , index: 12
        , path: '/common-door-schedule'
        , text: 'Common Door Schedule'
        , userGroups:  [ UserGroup.CommonDoorSchedule ]

    },

    {
        
        component: <Maintenance />
        , display: false
        , icon: <ConstructionIcon/>        
        , index: 11
        , path: '/maintenance'
        , text: 'Maintenance'
        , userGroups:  []

    },


];

export default views;